import { QBox } from '@qualio/ui-components';
import { useContext } from 'react';
import { getRevisionHistoryEditClass } from '../../../../util/EditModeUtils';
import { DocumentOverviewContext } from '../Context';

type RevisionHistorySidebarProps = {
  id:
    | 'commentsSidebar-revision-history'
    | 'changeControlSidebar-revision-history';
};

export const RevisionHistorySidebar = ({ id }: RevisionHistorySidebarProps) => {
  const { qualioDocument } = useContext(DocumentOverviewContext);
  return (
    <QBox
      px={2}
      py={4}
      id={id}
      className={`revision-history__sidebar ${getRevisionHistoryEditClass(
        qualioDocument,
      )}`}
    />
  );
};
